import { Dispatch, SetStateAction, useCallback, useEffect, useState } from "react"
import {
  useBeforeUnload,
  useBlocker,
} from "react-router-dom";

const usePrompt = (when: boolean): any => {
  const blocker = useBlocker(when)
  useEffect(() => {
    if (blocker.state === "blocked" && !when) {
      blocker.reset()
    }
  }, [blocker, when])

  useBeforeUnload(
    useCallback(
      (event) => {
        if (
          (when)
        ) {
          event.preventDefault();
          event.returnValue = '';
        }
      },
      [when],
    ),
    { capture: true },
  )

  return blocker
}

declare type InitialStateType = [boolean, Dispatch<SetStateAction<boolean>>, boolean, () => void, () => void];

export const useNavigationPrompt = (): InitialStateType => {
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const blocker = usePrompt(unsavedChanges);

  const resetConfirmation = () => {
    if (blocker.state === "blocked") blocker.reset()
  }

  const onConfirm = () => {
    if (blocker.state === "blocked") setTimeout(blocker.proceed, 0)
  }

  return [unsavedChanges, setUnsavedChanges, blocker.state === "blocked", onConfirm, resetConfirmation];
}